'use strict';

module.exports = require('./is-implemented')() ? WeakMap : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// ./~/es6-weak-map/index.js
// module id = 2691
// module chunks = 0